// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"city-12"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M17 21V11H7V21H17Z"},"nodeName":"path","children":[]},{"attributes":{"id":"fill2"},"nodeName":"g","children":[{"attributes":{"fill":"transparent","d":"M21 21V6H15V11H17V21H21Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"transparent","d":"M3 21H7V11H9V3H3V21Z"},"nodeName":"path","children":[]}]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M12 21V16M21 6V21H17V11H15V6H21ZM7 21H3V3H9V11H7V21Z","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M17 21V11H7V21H17Z","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-city-12')
export default class City12Icon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'city-12',
    }
  }
}
